export enum StandardSetType {
  Envision = 'enVision',
  Renaissance = 'renaissance'
}

export interface StandardSetModel {
  instructionDescription: string;
  standardDescription: boolean;
  standardSetType: StandardSetType;
  instructionEnVisionRealizeTitle: string;
}

export const StandardSetSettings: StandardSetModel[] = [
  {
    instructionDescription: 'Find high-quality, Standards-aligned resources from your core curriculum provider',
    standardDescription: true,
    standardSetType: StandardSetType.Envision,
    instructionEnVisionRealizeTitle: 'enVision Mathematics 2024',
  },
  {
    instructionDescription: 'Find high-quality, Standards-aligned resources from your Savvas curriculum',
    standardDescription: false,
    standardSetType: StandardSetType.Renaissance,
    instructionEnVisionRealizeTitle: 'Savvas Realize',
  }
]
